export default (icon: string) => import(/* webpackMode: "eager" */ `./${icon}.vue`)
